<template>
<div class="chapter">
<div class="inner_page">
<div class="copyright" id="cop">
<p class="crt"><a id="pii"></a>Copyright © 2007 by Kirsten Holmstedt</p>
<p class="crt">Published by<br/>STACKPOLE BOOKS<br/>5067 Ritter Road<br/>Mechanicsburg, PA 17055<br/><a class="pubhlink" href="http://www.stackpolebooks.com" target="_blank">www.stackpolebooks.com</a></p>
<p class="crt">All rights reserved, including the right to reproduce this book or portions thereof in any form or by any means, electronic or mechanical, including photocopying, recording, or by any information storage and retrieval system, without permission in writing from the publisher. All inquiries should be addressed to Stackpole Books, 5067 Ritter Road, Mechanicsburg, Pennsylvania 17055.</p>
<p class="crt">Printed in the United States of America</p>
<p class="crt">10 9 8 7 6 5 4 3 2 1</p>
<p class="crt">FIRST EDITION<br/><br/><br/><br/></p>
<p class="crt"><strong>Library of Congress Cataloging-in-Publication Data</strong></p>
<p class="crt">Holmstedt, Kirsten A.<br/>    Band of sisters : American women at war in Iraq / Kirsten A. Holmstedt.—<br/>  1st ed.<br/>       p. cm.<br/>  Includes index.<br/>  ISBN-13: 978-0-8117-0267-6<br/>  ISBN-10: 0-8117-0267-7<br/>  1. Iraq War, 2003—-Women—United States—Biography. 2. Women sailors—United States—Biography. I. Title.</p>
<p class="crt">DS79.76.H652 2007<br/>956.7044’34092273—dc22</p>
<p class="crt1">2007002680</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780811740111_epub_cop_r1.vue?2b73607c